<template>
  <div class="Social">
    <ul>
      <!-- <li><a href="#" target="_blank"><i class="fab fa-facebook-f"></i></a></li>
      <li><a href="#" target="_blank"><i class="fab fa-linkedin-in"></i></a></li> -->
      <li><a href="https://www.instagram.com/arttransplant1/" target="_blank"><i class="fab fa-instagram"></i></a></li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'Social',
  components: {
  },
  computed: {
  },
  mounted () {
  },
  data () {
    return {
    };
  }
};
</script>
<style lang='scss' scoped>
@import '../scss/colors.scss';

.Social {
    ul {
        display: flex;

        li {
            list-style-type: none;
            margin: 0;
            
            &:not(:first-child) { 
                margin-left: 25px; 
            }

            a {
               color: $white;
            }
        }
    }
}
</style>
